import {
  RouterProvider,
  useNavigate,
  matchPath,
  useParams,
  useSearchParams,
  useMatch,
  matchRoutes,
  useBlocker,
  Outlet,
  Navigate,
  createBrowserRouter,
  RouteObject,
  NavigateProps,
  useRouteError,
  NavigateFunction,
  useNavigationType,
} from 'react-router-dom';

import Link from './Link';
import RouterUtils from './utils';
import { PrivateRoute, AnonymousRoute, RedirectRoute } from './CustomRoutes';
import RouterErrorBoundary from './RouterErrorBoundary';
import useURLSearchParams from './useURLSearchParams';
import { useLocation } from './useLocation';

export {
  Link,
  matchPath,
  useParams,
  useSearchParams,
  RouterUtils,
  useNavigate,
  useLocation,
  useURLSearchParams,
  useMatch,
  matchRoutes,
  useBlocker,
  Outlet,
  Navigate,
  createBrowserRouter,
  useRouteError,
  PrivateRoute,
  AnonymousRoute,
  RedirectRoute,
  RouterErrorBoundary,
  useNavigationType,
};

export type { RouteObject, NavigateProps, NavigateFunction };

export default RouterProvider;
